// src/components/classification/ClassificationDetail.js

import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    CircularProgress,
    Alert,
    Grid
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useNavigate, useParams } from 'react-router-dom';
import useAuthenticatedData from '../../hooks/useAuthenticatedData';
import config from '../../config';
import { enterpriseGridOverrideTheme } from '../../themes/EnterpriseGridTheme';

import ClassificationSummary from './ClassificationSummary';
import QuoteTable from './QuoteTable';
import QuoteDiagram from './QuoteDiagram';
import ILSDiagram from './ILSDiagram';

const ClassificationDetail = () => {
    const { id } = useParams();                   // the classificationId
    const navigate = useNavigate();
    const { data: parts, isLoading, error } = useAuthenticatedData(
        `${config.apiBaseUrl}/classification/${id}/parts`
    );


    const handleRowClick = (params) => {
        console.log('Selected part:', params.row.partnumber);


    };

    // track which part the user has clicked
    const [selectedPart, setSelectedPart] = useState(null);

    if (isLoading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error.message}</Alert>;

    if (!parts) return <CircularProgress />;

    const columns = [
        { field: 'partnumber', headerName: 'Partnumber', width: 150 },
        { field: 'oldClass', headerName: 'Old Classification', width: 180 },
        { field: 'newClass', headerName: 'New Classification', width: 180 },
    ];



    return (
        <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Classification #{id}
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
                <Box sx={{ flex: 1, height: 300 }}>
                    <DataGrid
                        sx={enterpriseGridOverrideTheme}
                        rows={parts}
                        columns={columns}
                        onRowClick={handleRowClick}

                        slots={{ toolbar: GridToolbar }}

                        slotProps={{
                            toolbar: {
                                showQuickFilter: true, // Enable quick filter
                                quickFilterProps: { debounceMs: 500 }, // Add debounce to avoid too many filter operations
                                csvOptions: { fileName: 'export' },
                                printOptions: { fileName: 'export' }
                            }
                        }}
                    />
                </Box>

                <Box sx={{ flex: 1 }}>
                    <ClassificationSummary classificationId={id} />
                </Box>
            </Box>

            {selectedPart && (
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Details for {selectedPart}
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <QuoteTable
                                partNumber={selectedPart}
                                classificationId={id}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <QuoteDiagram
                                partNumber={selectedPart}
                                classificationId={id}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ILSDiagram
                                partNumber={selectedPart}
                                classificationId={id}
                            />
                        </Grid>
                    </Grid>
                </Box>
            )}
        </Paper>
    );
};

export default ClassificationDetail;
